/* NP-POPUP — trigger + a11y + CRM submit. Owned by npgummy-exit-intent-popup-crm.
   Mechanics modelled on gruns.co's welcome popup (observed live 2026-08-26:
   time trigger a few seconds in, same modal on exit intent, dismissal memory in
   localStorage), tuned to this brief: dwell default 20s, desktop exit intent on
   mouseleave toward the viewport top, a fast-scroll-up heuristic on touch
   devices (mouseleave does not exist there), fires once, remembers dismissal
   30 days and a successful submit 365 days, never on /cart|/checkout, never
   over another open modal (cart drawer, mobile nav, :target legal panels). */
(function () {
  'use strict';

  var root = document.querySelector('[data-npp]');
  if (!root) return;

  /* never on cart or checkout (checkout is a different origin/layout on
     Shopify, but belt over suspenders) */
  if (/^\/(cart|checkouts?)(\/|$)/.test(location.pathname)) return;

  var KEY = 'np-popup-v1';
  var delayMs = (parseInt(root.getAttribute('data-delay'), 10) || 20) * 1000;
  var dismissDays = parseInt(root.getAttribute('data-days'), 10) || 30;
  var endpoint = root.getAttribute('data-endpoint');

  function readStore() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function save(kind) {
    try { localStorage.setItem(KEY, JSON.stringify({ kind: kind, ts: Date.now() })); } catch (e) {}
  }
  function suppressed() {
    var s = readStore();
    if (!s || !s.ts) return false;
    var windowDays = s.kind === 'submit' ? 365 : dismissDays;
    return (Date.now() - s.ts) < windowDays * 864e5;
  }
  if (suppressed()) return;

  var card = root.querySelector('.npp-card');
  var form = root.querySelector('[data-npp-form]');
  var quiz = root.querySelector('[data-npp-quiz]');
  var answer = '';
  var intro = root.querySelector('[data-npp-intro]');
  var done = root.querySelector('[data-npp-done]');
  var doneTitle = root.querySelector('[data-npp-done-title]');
  var emailInput = root.querySelector('#npp-email');
  var errEl = root.querySelector('[data-npp-err]');
  var openerEl = null, isOpen = false, fired = false, retries = 0;

  function otherModalOpen() {
    if (document.documentElement.classList.contains('np-lock')) return true; /* cart drawer lock */
    if (document.querySelector('.drawer.open, .mnav.open')) return true;
    if (location.hash && location.hash.indexOf('legal') !== -1) return true;  /* :target legal panels */
    return false;
  }

  function fire() {
    if (fired || isOpen || suppressed()) return;
    if (otherModalOpen()) {
      /* another modal has the screen — try again shortly, give up after 6 tries */
      if (retries++ < 6) setTimeout(fire, 15000);
      return;
    }
    fired = true;
    openPopup();
  }

  /* trigger 1 — dwell */
  setTimeout(fire, delayMs);

  /* trigger 2 — desktop exit intent: pointer leaves the document toward the top */
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) fire();
  });

  /* trigger 3 — touch exit-intent heuristic: they read down the page, then
     flick back up fast (headed for the URL bar / back control). Requires real
     depth first (>600px) and genuine velocity (>1.1 px/ms upward). */
  var lastY = window.pageYOffset, lastT = Date.now(), deepestY = 0;
  window.addEventListener('scroll', function () {
    var y = window.pageYOffset, now = Date.now();
    if (y > deepestY) deepestY = y;
    var dy = lastY - y, dt = now - lastT;
    if (dt > 0 && dt < 400 && dy > 60 && deepestY > 600 && (dy / dt) > 1.1) fire();
    lastY = y; lastT = now;
  }, { passive: true });

  function focusables() {
    /* offsetParent is null for display:none nodes — without this filter the
       buttons inside the hidden success panel count as "last" and the Tab
       wrap never fires (caught live 2026-08-26) */
    var all = card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(all, function (el) { return el.offsetParent !== null; });
  }

  function openPopup() {
    isOpen = true;
    openerEl = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('npp-in'); });
    });
    document.documentElement.classList.add('npp-lock');
    document.addEventListener('keydown', onKey, true);
    card.focus();
  }

  function closePopup(kind) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('npp-in');
    document.documentElement.classList.remove('npp-lock');
    document.removeEventListener('keydown', onKey, true);
    setTimeout(function () { root.hidden = true; }, 300);
    save(kind || 'dismiss');
    if (openerEl && typeof openerEl.focus === 'function') {
      try { openerEl.focus(); } catch (e) {}
    }
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closePopup('dismiss'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-npp-close]')) {
      e.preventDefault();
      closePopup(done && !done.hidden ? 'submit' : 'dismiss');
      return;
    }
    /* gruns-style step 1: one qualifying question, then the email form */
    var opt = e.target.closest('[data-npp-opt]');
    if (opt) {
      answer = (opt.textContent || '').trim();
      if (quiz) quiz.hidden = true;
      if (intro) intro.hidden = false;
      if (emailInput) { try { emailInput.focus(); } catch (err) {} }
    }
  });

  function showErr(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.hidden = false;
  }

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errEl) errEl.hidden = true;
    var email = (emailInput && emailInput.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showErr('That email does not look right. One more try.');
      if (emailInput) emailInput.focus();
      return;
    }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(answer ? { emailAddress: email, description: 'Popup answer: ' + answer } : { emailAddress: email })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      save('submit');
      if (intro) intro.hidden = true;
      if (done) done.hidden = false;
      if (doneTitle) doneTitle.focus();
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      showErr('That did not go through. Give it another try in a second.');
    });
  });
})();
